export enum Payments {
    CASH = 'cash',
    BANK = 'bank',
    PAYPAL = 'paypal'
}